import script from "./OverlayGradient.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayGradient.vue?vue&type=script&setup=true&lang=js"

import "./OverlayGradient.vue?vue&type=style&index=0&id=5e9978b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9978b1"]])

export default __exports__